import { render, staticRenderFns } from "./AllTill.vue?vue&type=template&id=2bb85bc6&"
import script from "./AllTill.vue?vue&type=script&lang=js&"
export * from "./AllTill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports